;(function () {
  angular
    .module('contrast.integrations')
    .controller('GitHubIntegrationCtrl', GitHubIntegrationCtrl)

  function GitHubIntegrationCtrl(
    $scope,
    $q,
    $location,
    $translate,
    $routeParams,
    ErrorService,
    GitHubService,
    integrationService,
    UserService,
    rulesBugtrackerService,
    ApplicationFactory,
    INTEGRATION_TYPE,
    BASIC_AUTH_I18_STR,
    GITHUB_BASIC_AUTH,
    GITHUB_AUTH_TYPES,
    GITHUB_NONE_VAL,
    VULN_STATUS,
    VULN_STATUS_FIXED,
    VULNERABILITY_SUBSTATUS
  ) {
    'ngInject'

    var githubId = $routeParams.githubId
    var allApplications, allRules
    var _allOptionValue = 'All'
    var rules = []

    angular.extend($scope, {
      adding: false,
      applicationsPromise: undefined,
      errorCode: undefined,
      errorMsgs: [],
      fieldErrors: [],
      integrationPromise: undefined,
      rulesPromise: undefined,
      refreshPromise: undefined,
      model: {
        name: '',
        host: '',
        auth_type: undefined,
        username: '',
        password: '',
        token: '',
        applications: [],
        all_applications: false,

        github_organization: undefined,
        repository: undefined,

        labels: [],
        assignees: [],
        milestone: '',

        assignee: GITHUB_NONE_VAL,
        issue_type: GITHUB_NONE_VAL,
        project: GITHUB_NONE_VAL,

        auto_create_tickets_enabled: false,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules: false,

        placeholderURL: 'https://hostname'
      },
      previousOrg: '',
      previousRepo: '',
      isEdit: false,
      autoCreateTicketsEnabled: false,
      projectsPromise: undefined,
      select: {
        applications: [],
        auth_types: GITHUB_AUTH_TYPES,
        organizations: [],
        repositories: [],
        labels: [],
        milestones: [],
        assignees: [],
        all_trace_status: angular.copy(VULN_STATUS),
        trace_substatus: angular.copy(VULNERABILITY_SUBSTATUS)
      },
      show: {
        basicAuth: false,
        token: true
      },
      isUrlTested: false
    })

    angular.extend($scope, {
      save: save,
      deleteIntegration: deleteIntegration,
      onApplicationsUpdated: onApplicationsUpdated,
      onApplicationsDeleted: onApplicationsDeleted,
      invalidForm: invalidForm,
      getIntegration: getIntegration,
      getApplications: getApplications,
      cancelCreation: cancelCreation,
      resetConnection: resetConnection,
      testConnection: testConnection,
      displayAuthText: displayAuthText,
      onAuthenticationChange: onAuthenticationChange,
      onChangeOrganization: onChangeOrganization,
      onChangeRepository: onChangeRepository,
      enableAutoCreateTickets: enableAutoCreateTickets,
      onRulesUpdated: onRulesUpdated,
      onRulesDeleted: onRulesDeleted
    })

    function init() {
      $scope.select.all_trace_status.push(VULN_STATUS_FIXED)
      $scope.model.auth_type = GITHUB_AUTH_TYPES[0]
      onAuthenticationChange(false)

      $scope.applicationsPromise = getApplications()
      $scope.rulesPromise = _getRules()

      $q.all([$scope.applicationsPromise, $scope.rulesPromise]).then(
        function () {
          _populateRulesComboBox()

          if (angular.isDefined(githubId)) {
            $scope.isEdit = true
            $scope.integrationPromise = getIntegration()

            $q.all([$scope.integrationPromise]).then(function () {
              $scope.previousOrg = $scope.model.github_organization.login
              $scope.previousRepo = $scope.model.repository.name

              if (GITHUB_BASIC_AUTH === $scope.model.auth_type) {
                $scope.model.auth_type = GITHUB_AUTH_TYPES[0]
              } else {
                $scope.model.auth_type = GITHUB_AUTH_TYPES[1]
              }
              onAuthenticationChange(false)

              var selectedApps = _.filter(
                $scope.select.applications,
                function (app) {
                  return _.includes($scope.selected_appdids, app.app_id)
                }
              )

              if ($scope.model.all_applications || selectedApps.length === 0) {
                $scope.model.applications = [allApplications]
                $scope.model.all_applications = true
              } else {
                $scope.model.applications = selectedApps
                $scope.model.all_applications = false
              }

              if ($scope.model.auto_create_tickets_enabled) {
                $scope.autoCreateTicketsEnabled = true
                $scope.model.auto_create_tickets_rules =
                  rulesBugtrackerService.buildRules(
                    $scope.model.auto_create_tickets_rules,
                    $scope.model.auto_create_tickets_severities
                  )
                _setAutoCreateTicketsEnabled()
              } else {
                _setDefaultSeveritiesAsRules()
              }
            })
          } else {
            _setDefaultSeveritiesAsRules()
          }
        }
      )
    }

    function deleteIntegration() {
      integrationService
        .deleteIntegration($scope.model, INTEGRATION_TYPE.GITHUB, githubId)
        .then(function (deleted) {
          if (deleted) {
            $location.path(UserService.buildUrl('/settings/integration'), true)
          }
        })
    }

    // Add here functions for two-way integration

    function onApplicationsUpdated() {
      _updateMultiSelect($scope.model.applications)
      $scope.model.all_applications = false
    }

    function onApplicationsDeleted() {
      $scope.model.all_applications = _deleteMultiSelect(
        $scope.model.applications,
        allApplications
      )
    }

    function invalidForm() {
      var invalid =
        $scope.form.name.$invalid ||
        $scope.form.host.$invalid ||
        (angular.isDefined($scope.model.applications) &&
          $scope.model.applications.length === 0)

      // Validate according to the auth type
      if (!invalid && $scope.show.basicAuth) {
        invalid =
          invalid ||
          $scope.form.username.$invalid ||
          $scope.form.password.$invalid
      } else {
        invalid = invalid || $scope.form.token.$invalid
      }

      invalid =
        $scope.form.repository.$invalid ||
        $scope.form.github_organization.$invalid

      return invalid
    }

    function getIntegration() {
      $scope.isUrlTested = true
      $scope.testing = true
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false

      return GitHubService.getGitHubBugtracker(githubId)
        .then(function (data) {
          $scope.showValidConnection = true
          $scope.model = GitHubService.buildGitHubBugtracker(data.bugtracker)

          // Set default empty
          $scope.model.assignee = GITHUB_NONE_VAL
          $scope.model.issue_type = GITHUB_NONE_VAL
          $scope.model.project = GITHUB_NONE_VAL

          var selectedOrg = data.settings.selected_organization
          $scope.model.github_organization = selectedOrg.organization
          $scope.model.repository = selectedOrg.repository_settings.repository

          _fillOrganizations(data.settings.organizations)
          _fillRepositories(
            selectedOrg.repositories,
            $scope.model.github_organization.login
          )
          _fillRepositorySettings(selectedOrg.repository_settings)

          $scope.selected_appdids = data.bugtracker.applications
        })
        .catch(function (data) {
          $scope.showInvalidConnection = true

          $scope.errorCode = data.errorCode
          $scope.errorMsgs = data.errorMsgs
        })
        .finally(function () {
          $scope.testing = false
        })
    }

    function getApplications() {
      return ApplicationFactory.getApplications('', false, '', '', false).then(
        function (response) {
          $scope.select.applications = response.data.applications

          var transl = {
            title_allApplications: $translate.instant('title_allApplications')
          }

          allApplications = {
            name:
              transl.title_allApplications +
              ' (' +
              $scope.select.applications.length +
              ')',
            app_id: _allOptionValue
          }

          $scope.select.applications.push(allApplications)

          if (angular.isUndefined(githubId)) {
            $scope.model.applications.push(allApplications)
            $scope.model.all_applications = true
          }
        },
        ErrorService.processError
      )
    }

    function save() {
      $scope.adding = true

      if (!$scope.model.auto_create_tickets_enabled) {
        $scope.model.auto_create_tickets_rules = []
        $scope.model.auto_create_tickets_severities = []
        $scope.model.auto_create_tickets_all_rules = false
      }

      var request = GitHubService.buildGitHubIntegration($scope.model)

      // Add two way integration here

      if ($scope.isEdit) {
        updateIntegration(githubId, request)
      } else {
        createIntegration(request)
      }
    }

    function createIntegration(request) {
      GitHubService.addGitHubBugtracker(request).finally(function () {
        $scope.adding = false
      })
    }

    function updateIntegration(githubId, request) {
      GitHubService.editGitHubBugtracker(githubId, request).finally(
        function () {
          $scope.adding = false
        }
      )
    }

    function cancelCreation() {
      $scope.model = {
        name: '',
        host: '',
        auth_type: undefined,
        username: '',
        password: '',
        applications: [],
        all_applications: false,

        github_organization: undefined,
        repository: undefined,

        assignee: GITHUB_NONE_VAL,
        issue_type: GITHUB_NONE_VAL,
        project: GITHUB_NONE_VAL,

        auto_create_tickets_enabled: false,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules: false,

        placeholderURL: 'https://hostname'
      }

      $scope.select = {
        applications: [],
        auth_types: GITHUB_AUTH_TYPES,
        organizations: [],
        repositories: [],
        labels: [],
        milestones: [],
        assignees: []
      }

      GitHubService.clearCache()

      $location.path(UserService.buildUrl('/settings/integration'), true)
    }

    function testConnection() {
      $scope.isUrlTested = true
      $scope.testing = true
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false
      $scope.model.host = $scope.model.host.replace(/(\/)$/, '')

      var request = GitHubService.buildGitHubIntegrationTest($scope.model)

      var bugtrackerPromise = $scope.isEdit
        ? GitHubService.testExistingGitHubBugtracker(githubId, request)
        : GitHubService.testGitHubBugtracker(request)

      bugtrackerPromise
        .then(function (response) {
          $scope.showValidConnection = true

          if (_shouldResetIntegrationSettings(response)) {
            return
          }

          var selectedOrg = response.selected_organization
          $scope.model.github_organization = selectedOrg.organization
          $scope.model.repository = selectedOrg.repository_settings.repository

          _fillOrganizations(response.organizations)
          _fillRepositories(
            selectedOrg.repositories,
            $scope.model.github_organization.login
          )
          _fillRepositorySettings(selectedOrg.repository_settings)
        })
        .catch(function (data) {
          $scope.showInvalidConnection = true

          $scope.errorCode = data.error_code
          $scope.errorMsgs = data.bugtracker_errors

          if (data.errors) {
            $scope.errorCode = 400
            $scope.fieldErrors = data.errors
          }
        })
        .finally(function () {
          $scope.testing = false
        })
    }

    function displayAuthText(text) {
      if (BASIC_AUTH_I18_STR == text) {
        return $translate.instant(text)
      }
      return text
    }

    function onAuthenticationChange(reset) {
      $scope.show.basicAuth = GITHUB_BASIC_AUTH === $scope.model.auth_type.value
      $scope.show.token = !$scope.show.basicAuth

      if (reset) {
        resetConnection()
      }
    }

    function onChangeOrganization() {
      if ($scope.previousOrg == $scope.model.github_organization.login) {
        return
      }

      $scope.previousOrg = $scope.model.github_organization.login
      $scope.model.repository = undefined
      _refreshIntegrationSettings()
    }

    function onChangeRepository() {
      if ($scope.previousRepo == $scope.model.repository.name) {
        return
      }

      $scope.previousRepo = $scope.model.repository.name
      _refreshIntegrationSettings()
    }

    function _refreshIntegrationSettings() {
      // Reset repository fields
      $scope.model.labels = []
      $scope.model.milestone = ''
      $scope.model.assignees = []

      var request = GitHubService.buildGitHubIntegrationTest($scope.model)

      $scope.refreshPromise = $scope.isEdit
        ? GitHubService.refreshExistingGitHubBugtracker(githubId, request)
        : GitHubService.refreshGitHubBugtracker(request)

      $scope.refreshPromise
        .then(function (response) {
          // Update lists and fields
          var selectedOrg = response.selected_organization
          _fillRepositories(
            selectedOrg.repositories,
            $scope.model.github_organization.login
          )
          _fillRepositorySettings(selectedOrg.repository_settings)
        })
        .catch(function (data) {
          $scope.errorCode = data.error_code
          $scope.errorMsgs = data.bugtracker_errors
        })
    }

    function resetConnection() {
      $scope.isUrlTested = false
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false
      $scope.errorCode = undefined
      $scope.errorMsgs = []
    }

    function enableAutoCreateTickets() {
      $scope.model.auto_create_tickets_enabled =
        !$scope.model.auto_create_tickets_enabled
      if ($scope.model.auto_create_tickets_enabled) {
        _setAutoCreateTicketsEnabled()
      }
    }

    function onRulesUpdated() {
      _updateRulesMultiSelect($scope.model.auto_create_tickets_rules)
      $scope.model.auto_create_tickets_all_rules = false
    }

    function onRulesDeleted() {
      $scope.model.auto_create_tickets_all_rules = _deleteMultiSelect(
        $scope.model.auto_create_tickets_rules,
        allRules
      )
    }

    function _updateMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.app_id === _allOptionValue
      })

      if (index != -1) {
        array.splice(index, 1)
      }
    }

    function _updateRulesMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.value === _allOptionValue
      })

      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    function _deleteMultiSelect(array, allOption) {
      if (array.length == 0) {
        array.push(allOption)
        return true
      } else {
        return false
      }
    }

    function _shouldResetIntegrationSettings(settings) {
      if (settings.organizations && settings.organizations.length > 0) {
        return false
      }
      $scope.select.organizations = []
      $scope.select.repositories = []
      $scope.select.labels = []
      $scope.select.milestones = []
      $scope.select.assignees = []

      $scope.model.github_organization = undefined
      $scope.model.repository = undefined
      $scope.model.labels = []
      $scope.model.assignees = []
      $scope.model.milestone = ''
      return true
    }

    function _fillOrganizations(organizations) {
      if (organizations && organizations.length > 0) {
        $scope.select.organizations = organizations

        if (angular.isUndefined($scope.model.github_organization)) {
          $scope.model.github_organization = organizations[0]
        } else if (angular.isString($scope.model.github_organization)) {
          $scope.model.github_organization = _.find(
            $scope.select.organizations,
            { login: $scope.model.github_organization }
          )
        }
        $scope.previousOrg = $scope.model.github_organization.login
      } else {
        $scope.select.organizations = []
      }
    }

    function _fillRepositories(repositories, githubOrg) {
      if (repositories && repositories.length > 0) {
        $scope.select.repositories = repositories

        if (angular.isUndefined($scope.model.repository)) {
          $scope.model.repository = repositories[0]
        } else if (angular.isString($scope.model.repository)) {
          $scope.model.repository = _.find($scope.select.repositories, {
            name: $scope.model.repository
          })
        }

        if (
          $scope.model.repository.name === $scope.select.repositories[0].name
        ) {
          GitHubService.updateRepositoryCache(
            githubOrg,
            $scope.model.repository.name
          )
        }
        $scope.previousRepo = $scope.model.repository.name
      } else if (angular.isUndefined($scope.model.repository)) {
        $scope.select.repositories = []
      }
    }

    function _fillRepositorySettings(settings) {
      if (!settings) {
        $scope.select.labels = []
        $scope.select.milestones = []
        $scope.select.assignees = []
        return
      }
      var labels = settings.labels
      var milestones = settings.milestones
      var assignees = settings.assignees

      // Labels setup
      if (labels && labels.length > 0) {
        $scope.select.labels = labels

        if (angular.isDefined($scope.model.labels)) {
          var selectedLabels = _.filter($scope.select.labels, function (label) {
            return _.includes($scope.model.labels, label.name)
          })

          if ($scope.model.labels && selectedLabels.length > 0) {
            $scope.model.labels = selectedLabels
          }
        }
      } else {
        $scope.select.labels = []
      }
      // Milestone setup
      if (milestones && milestones.length > 0) {
        $scope.select.milestones = milestones

        if (angular.isDefined($scope.model.milestone)) {
          $scope.model.milestone = _.find($scope.select.milestones, {
            number: $scope.model.milestone
          })
        }
      } else {
        $scope.select.milestones = []
      }
      // Assignees setup
      if (assignees && assignees.length > 0) {
        $scope.select.assignees = assignees

        if (angular.isDefined($scope.model.assignees)) {
          var selectedAssignees = _.filter(
            $scope.select.assignees,
            function (assignee) {
              return _.includes($scope.model.assignees, assignee.login)
            }
          )

          if ($scope.model.assignees && selectedAssignees.length > 0) {
            $scope.model.assignees = selectedAssignees
          }
        }
      } else {
        $scope.select.assignees = []
      }
    }

    function _getRules() {
      return rulesBugtrackerService.getRules().then(function (rulesFound) {
        rules = rulesFound
        allRules = {
          name:
            $translate.instant('title_allRules') +
            '(' +
            rulesFound.length +
            ')',
          value: _allOptionValue
        }
      })
    }

    function _populateRulesComboBox() {
      $scope.select.rules =
        rulesBugtrackerService.buildRulesWithAllSeverities(rules)
    }

    function _setDefaultSeveritiesAsRules() {
      var defaultSeverities = angular.copy(
        rulesBugtrackerService.buildRulesWithDefaultSeverities()
      )

      $scope.model.auto_create_tickets_rules = []
      $scope.model.auto_create_tickets_severities = []
      $scope.model.auto_create_tickets_all_rules = false

      var i
      for (i = 0; i < defaultSeverities.length; i++) {
        $scope.model.auto_create_tickets_rules.push(defaultSeverities[i])
      }
    }

    function _setAutoCreateTicketsEnabled() {
      if ($scope.model.auto_create_tickets_all_rules) {
        _setAutoCreateTicketsEnabledWithAllRules()
      } else {
        _setAutoCreateTicketsEnabledWithCustomizedRules()
      }
    }

    function _setAutoCreateTicketsEnabledWithAllRules() {
      $scope.model.auto_create_tickets_rules = [allRules]
      $scope.model.auto_create_tickets_severities = []
      $scope.model.auto_create_tickets_all_rules = true
    }

    function _setAutoCreateTicketsEnabledWithCustomizedRules() {
      $scope.model = GitHubService.transformToIntegrationView(
        $scope.model,
        $scope.select.rules
      )
    }

    init()
  }
})()
